var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',_vm._g(_vm._b({},'Modal',_vm.$props,false),_vm.eventBind),[_c('div',{style:({
      maxHeight: _vm.maxHeight ? _vm.maxHeight : 'calc(100vh - 250px)',
      overflow: 'auto',
    })},[_vm._t("default")],2),_vm._t("footer",function(){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('Button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":function($event){return _vm.$emit('on-ok')}}},[_vm._v("提交")]),_c('Button',{on:{"click":function($event){return _vm.$emit('input', false)}}},[_vm._v("取消")])],1)]},{"slot":"footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }